export default "__VITE_ASSET__DhaTz4Bp__"